<template>
  <v-col cols="12">
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Target Lift</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn small fab color="primary" @click="onAddTargetLift(serie)">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-expansion-panels v-if="serie.targetLiftPosition != 0">
      <draggable
        v-model="serie.targetLiftPosition"
        @start="drag = true"
        @end="
          drag = false;
          onDragEnd();
        "
        handle=".draghandle"
        style="width: 100%"
      >
        <v-expansion-panel v-for="(targetLift, serieIndex) in serie.targetLiftPosition" :key="serieIndex">
          <v-expansion-panel-header @click="panelClicked(serieIndex)">
            <template>
              <v-fade-transition leave-absolute>
                <v-row no-gutters align="center" cols="3">
                  <v-col>
                    <v-btn cols="4" icon class="draghandle">
                      <v-icon>mdi-drag-horizontal</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="2">
                    <v-chip v-if="targetLift.position.defaultValue != ''" small color="primary"
                      >{{ getTargetLiftTypeToLowerCase(targetLift.position.defaultValue) }}
                    </v-chip>
                  </v-col>
                  <v-col cols="2" :class="`specifyShotIndic${serieIndex}`">
                    <span key="0">
                      {{ getShotNumber(targetLift, 'FROM') }} - {{ getShotNumber(targetLift, 'TO') }}
                    </span>
                  </v-col>
                  <v-spacer> </v-spacer>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon @click="onDeleteTargetLift(serieIndex)">mdi-close-thick</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-fade-transition>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col>
              <!-- <v-text-field
                v-model="procedureStep.time.from.defaultValue.value"
                label="Time"
                placeholder="Time"
                :rules="timeRule"
              ></v-text-field> -->
              <v-row>
                <v-col cols="3">
                  <div class="grey--text text-caption">Select default target type</div>
                  <v-combobox
                    style="margin-top: 5%"
                    :items="targetLiftTypes"
                    @input="setTargetLiftType($event, targetLift, 'TARGET_LIFT')"
                    :value="getTargetLiftTypeToLowerCase(targetLift.position.defaultValue)"
                    outlined
                    dense
                  ></v-combobox>
                </v-col>
                <v-col cols="2">
                  <div class="grey--text text-caption">Specify shot range</div>
                  <v-switch
                    :class="`switch${serieIndex}`"
                    :ref="`switch${serieIndex}`"
                    :input-value="
                      getShotNumber(targetLift, 'FROM') != 1 || getShotNumber(targetLift, 'TO') != serie.shots.count
                    "
                    @change="onSwitchPress($event, serieIndex)"
                  ></v-switch>
                </v-col>
                <v-col cols="3" style="margin-left: 5%" :class="`specifyShot${serieIndex}`">
                  <div class="grey--text text-caption">To and from shots</div>
                  <div
                    style="display: flex; flex-direction: row; justify-content: center; align-items: center; width: 70%"
                  >
                    <v-text-field
                      label="From"
                      min="1"
                      :max="serie.shots.count"
                      :value="getShotNumber(targetLift, 'FROM')"
                      @click="onShotChange($event, targetLift, 'FROM')"
                      type="number"
                    ></v-text-field>

                    <v-text-field
                      style="margin-left: 20px"
                      min="1"
                      :max="serie.shots.count"
                      label="To"
                      type="number"
                      :value="getShotNumber(targetLift, 'TO')"
                      @click="onShotChange($event, targetLift, 'TO')"
                    ></v-text-field>
                    <!-- :value="getShotNumber('TO', index)"  -->
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-toolbar color="grey lighten-3">
              <v-toolbar-title>Profiles</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn small fab color="primary" @click="onAddProfile(targetLift)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(profile, indexProfile) in targetLift.position.profileValues"
                :key="indexProfile"
              >
                <v-expansion-panel-header>
                  <v-col cols="4">
                    <span> {{ getProfileName(profile.id) }} </span>
                  </v-col>
                  <v-col cols="8">
                    <v-chip v-if="targetLift.position.defaultValue != ''" small color="primary"
                      >{{ getTargetLiftTypeToLowerCase(profile.value) }}
                    </v-chip>
                  </v-col>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon @click="onDeleteTargetLiftProfile(serieIndex, indexProfile)">mdi-close-thick</v-icon>
                    </v-btn>
                  </v-col>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row no-gutters>
                    <v-col cols="4">
                      <v-row>
                        <v-col>
                          <v-autocomplete
                            style="margin-top: 5%"
                            :items="getProfileObjectTable"
                            v-model="profile.id"
                            item-value="id"
                            item-text="value.value"
                            label="Profile"
                            required
                          ></v-autocomplete>
                        </v-col>
                        <v-col>
                          <div class="grey--text text-caption">Select target type</div>
                          <v-combobox
                            style="margin-top: 5%"
                            :items="targetLiftTypes"
                            @input="setTargetLiftType($event, profile, 'TARGET_LIFT_PROFILE')"
                            :value="getTargetLiftTypeToLowerCase(profile.value)"
                            outlined
                            dense
                          ></v-combobox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </draggable>
    </v-expansion-panels>
  </v-col>
</template>
<script>
  //   import * as helpers from '../../shootingProgramHelpers.js';
  //   import { v4 as uuidv4 } from 'uuid';
  import draggable from 'vuedraggable';
  export default {
    name: 'EditSeriesTargetLift',
    components: {
      draggable,
    },
    props: {
      profiles: Array,
      serie: Object,
    },

    data: () => ({
      targetLiftTypes: ['Prone', 'Kneeling', 'Standing', 'Park'],
    }),

    computed: {
      getProfileObjectTable() {
        var profileObjects = [];
        this.profiles.map((profile, index) => {
          profileObjects[index] = {
            value: {
              value: profile.name.value,
            },
            id: profile.id,
          };
        });

        return profileObjects;
      },
    },

    mounted() {
      this.resetShotRangeList();
    },

    methods: {
      onDragEnd() {
        this.resetShotRangeList();
      },
      panelClicked(index) {
        setTimeout(() => {
          let className = 'specifyShot' + index;
          if (
            this.serie.targetLiftPosition[index].shots.from == 0 &&
            this.serie.targetLiftPosition[index].shots.to == this.serie.shots.count - 1
          )
            document.getElementsByClassName(className)[0].style.display = 'none';
          else document.getElementsByClassName(className)[0].style.display = 'inline';
        }, 10);
      },
      resetShotRangeList() {
        for (let i = 0; i < this.serie.targetLiftPosition.length; i++) {
          let className2 = 'specifyShotIndic' + i;
          if (
            this.serie.targetLiftPosition[i].shots.from == 0 &&
            this.serie.targetLiftPosition[i].shots.to == this.serie.shots.count - 1
          )
            document.getElementsByClassName(className2)[0].style.display = 'none';
          else document.getElementsByClassName(className2)[0].style.display = 'inline';
        }
      },
      onSwitchPress(changeBool, index) {
        let className = 'specifyShot' + index;
        let className2 = 'specifyShotIndic' + index;

        if (changeBool) {
          document.getElementsByClassName(className)[0].style.display = 'inline';
          document.getElementsByClassName(className2)[0].style.display = 'inline';
        } else {
          document.getElementsByClassName(className)[0].style.display = 'none';
          document.getElementsByClassName(className2)[0].style.display = 'none';
          this.serie.targetLiftPosition[index].shots.from = 0;
          this.serie.targetLiftPosition[index].shots.to = this.serie.shots.count != 0 ? this.serie.shots.count - 1 : 0;
        }
      },
      getProfileName(profileID) {
        const profile = this.profiles.find((profile) => profile.id == profileID);

        return profile != undefined ? profile.name.value : '';
      },
      getTargetLiftTypeToLowerCase(type) {
        const newType = type.toString().toLowerCase();
        const formatedType = newType.charAt(0).toUpperCase() + newType.slice(1);
        return formatedType;
      },

      setTargetLiftType(type, targetLift, arrayType) {
        if (arrayType == 'TARGET_LIFT') targetLift.position.defaultValue = type.toUpperCase();
        else targetLift.value = type.toUpperCase();
      },
      onShotChange(number, targetLift, type) {
        if (type == 'FROM') {
          targetLift.shots.from = number.srcElement.value - 1;
        } else {
          targetLift.shots.to = number.srcElement.value - 1;
        }
      },
      getShotNumber(targetLift, type) {
        if (type == 'FROM') {
          return targetLift.shots.from + 1;
        } else {
          return targetLift.shots.to + 1;
        }
      },
      onAddTargetLift(serie) {
        const targetLiftPosition = {
          position: {
            defaultValue: '',
            profileValues: [],
          },
          shots: {
            from: 0,
            to: serie.shots.count != 0 ? serie.shots.count - 1 : 0,
          },
        };
        serie.targetLiftPosition.push(targetLiftPosition);

        this.$nextTick(function () {
          this.resetShotRangeList();
        });
      },
      onAddProfile(targetLift) {
        const ProfileValue = {
          value: targetLift.position.defaultValue != '' ? targetLift.position.defaultValue : '',
          id: '',
        };
        targetLift.position.profileValues.push(ProfileValue);
      },
      onDeleteTargetLift(index) {
        this.serie.targetLiftPosition.splice(index, 1);
      },
      onDeleteTargetLiftProfile(serieIndex, profileIndex) {
        this.serie.targetLiftPosition[serieIndex].position.profileValues.splice(profileIndex, 1);
      },
    },
  };
</script>
